// Initialize the dispatcher
import { dispatchEvent } from './Dispatcher';

// Register all vendors
import './Vendors';

// Dispatch an event to initialize all vendors
dispatchEvent({ type: 'init' });
